import { render, staticRenderFns } from "./UpdateOwnerDataModal.vue?vue&type=template&id=00bc3f50&"
import script from "./UpdateOwnerDataModal.vue?vue&type=script&lang=js&"
export * from "./UpdateOwnerDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports